var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomSoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 147.92 137.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);fill-opacity:.44;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#fff;}.cls-2,.cls-3,.cls-5{stroke-miterlimit:10;}.cls-3{fill:none;}.cls-6{fill:#2c75fb;}.cls-4{fill:#7da2fe;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-5{fill:rgba(255,255,255,.2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.1,
    y1: 62.99,
    x2: 116.99,
    y2: 62.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.74,40.97v89.36c0,3.48-2.82,6.31-6.31,6.31H17.99c-9.26,0-17.15-7.2-17.48-16.45,0-.21,0-.42,0-.63V17.59c0,.21,0,.42,0,.63,.33,9.26,8.22,16.45,17.48,16.45H122.43c3.49,0,6.31,2.82,6.31,6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.67,6.39V96.59c0,3.25-2.64,5.89-5.89,5.89h-11.2c-9.43,0-17.08,7.65-17.08,17.09V17.58C.5,8.15,8.15,.5,17.58,.5h11.2c3.25,0,5.89,2.64,5.89,5.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 97.71,
    y: 95.04,
    width: 48.14,
    height: 11.37,
    transform: "translate(-35.55 115.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.86,73.64h0c2.56,0,4.64,2.08,4.64,4.64v2.09c0,2.56-2.08,4.64-4.64,4.64h0v-11.37h0Z",
    transform: "translate(-14.16 124.48) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "94.2 128.3 98 116.46 106.05 124.5 94.2 128.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.2,83.78v44.52h44.53l-44.53-44.52Zm7.74,18.68l18.11,18.1h-18.11v-18.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 93.28,
    x2: 46.93,
    y2: 93.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 97.17,
    x2: 46.93,
    y2: 97.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 101.07,
    x2: 46.93,
    y2: 101.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 104.97,
    x2: 46.93,
    y2: 104.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 108.87,
    x2: 46.93,
    y2: 108.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 112.77,
    x2: 46.93,
    y2: 112.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 116.66,
    x2: 46.93,
    y2: 116.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.2,
    y1: 120.56,
    x2: 46.93,
    y2: 120.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.23,
    y1: 125.51,
    x2: 79.23,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.33,
    y1: 125.51,
    x2: 75.33,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 71.43,
    y1: 125.51,
    x2: 71.43,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.53,
    y1: 125.51,
    x2: 67.53,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.63,
    y1: 125.51,
    x2: 63.63,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.74,
    y1: 125.51,
    x2: 59.74,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.84,
    y1: 125.51,
    x2: 55.84,
    y2: 128.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.94,
    y1: 125.51,
    x2: 51.94,
    y2: 128.24
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.99 77.94 99.27 77.94 87.1 66.27 87.1 48.05 116.99 48.05 116.99 77.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.97,99.99c-1.07,0-2.14-.09-3.2-.27-.66-.11-1.17-.65-1.24-1.32l-.14-1.43c-.08-.88-.17-1.76-.25-2.64-.39-.16-.79-.32-1.18-.49-.75,.62-2.89,2.39-2.89,2.39-.07,.06-.14,.11-.22,.17-.29,.22-.66,.34-1.02,.34-.3,0-.59-.08-.83-.25-1.77-1.26-3.25-2.74-4.53-4.53-.38-.54-.37-1.27,.04-1.79l.21-.27s1.82-2.21,2.4-2.9c-.17-.39-.33-.79-.49-1.19-.62-.06-3.83-.35-3.83-.35-.85-.07-1.46-.65-1.6-1.5-.31-1.97-.31-3.98,0-5.97,.13-.85,.75-1.43,1.61-1.5,0,0,3.12-.29,3.81-.35,.16-.4,.32-.79,.49-1.18-.41-.49-2.59-3.13-2.59-3.13-.43-.52-.46-1.27-.07-1.82,1.25-1.76,2.78-3.29,4.55-4.54,.26-.18,.56-.28,.87-.28,.33,0,.65,.11,.92,.32l.25,.2s2.2,1.82,2.92,2.41c.39-.17,.78-.33,1.18-.48,.05-.52,.39-4.06,.39-4.06,.07-.67,.58-1.22,1.25-1.33,1.08-.18,2.17-.27,3.23-.27s2.15,.09,3.2,.28c.66,.12,1.16,.66,1.23,1.33l.14,1.47c.08,.86,.16,1.72,.24,2.58,.4,.16,.79,.32,1.18,.49,.19-.16,3.13-2.59,3.13-2.59,.28-.23,.62-.34,.96-.34,.3,0,.61,.09,.87,.28,1.81,1.29,3.29,2.77,4.55,4.54,.38,.54,.37,1.27-.04,1.79l-.21,.27-2.4,2.9c.1,.24,.42,1.02,.49,1.17,1.26,.12,2.52,.24,3.78,.35,.94,.08,1.6,.73,1.68,1.66,.05,.61,.11,1.21,.17,1.81,.08,.19,.13,.4,.13,.6v.76c0,.21-.04,.42-.13,.6l-.17,1.89c-.1,1.12-.93,1.59-1.61,1.65-.73,.06-3.29,.3-3.83,.35-.16,.4-.32,.79-.49,1.19l.78,.94c.54,.65,1.07,1.29,1.61,1.94,.65,.76,.63,1.73-.03,2.46-.26,.28-.51,.57-.76,.86-.51,.58-1.02,1.16-1.55,1.71-.42,.43-.87,.78-1.3,1.12-.17,.13-.34,.27-.51,.41-.28,.23-.62,.35-.96,.35s-.66-.11-.93-.33l-.29-.24s-2.21-1.83-2.89-2.39c-.4,.17-.79,.34-1.18,.49-.03,.35-.38,4.05-.38,4.05-.06,.68-.58,1.23-1.25,1.34-1.08,.18-2.16,.26-3.21,.26Zm.01-24.19c-2.85,0-5.17,2.32-5.17,5.17,0,1.38,.54,2.68,1.52,3.66,.98,.98,2.28,1.52,3.65,1.52,2.86,0,5.17-2.33,5.17-5.19,0-2.85-2.32-5.17-5.16-5.17v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84,63.45c.98,0,1.96,.08,2.94,.26,.03,.26,.05,.5,.07,.73,.12,1.32,.25,2.65,.37,3.98,.02,.2,.1,.29,.3,.36,.78,.3,1.56,.63,2.33,.96,.08,.03,.14,.05,.2,.05,.08,0,.15-.03,.23-.1,.48-.42,.98-.81,1.47-1.22,.72-.6,1.45-1.19,2.18-1.8,1.64,1.17,3.04,2.55,4.2,4.19-.07,.09-.13,.16-.19,.24-.94,1.14-1.88,2.28-2.83,3.41-.1,.12-.16,.2-.08,.38,.36,.81,.69,1.64,1.04,2.45,.04,.09,.16,.19,.26,.2,1.5,.15,3,.29,4.5,.42,.2,.02,.29,.08,.31,.29,.06,.7,.13,1.4,.2,2.1,0,.07,.06,.13,.09,.19v.76s-.03,0-.05,0h-.02s-.02,.04-.02,.05c-.07,.77-.14,1.54-.21,2.31-.01,.16-.04,.27-.25,.29-1.5,.13-3,.28-4.5,.41-.19,.02-.28,.09-.35,.27-.31,.8-.64,1.59-.99,2.38-.08,.18-.05,.27,.06,.41,.95,1.13,1.88,2.28,2.83,3.41,.16,.19,.17,.31,0,.49-.76,.84-1.48,1.72-2.28,2.53-.52,.53-1.13,.96-1.7,1.43-.12-.1-.2-.16-.27-.22-1.13-.94-2.27-1.87-3.39-2.81-.09-.08-.17-.12-.26-.12-.06,0-.12,.02-.2,.05-.77,.34-1.54,.67-2.32,.97-.2,.08-.27,.16-.29,.36-.06,.71-.13,1.42-.2,2.13-.08,.86-.16,1.71-.25,2.58-1,.16-1.98,.24-2.97,.24s-1.96-.08-2.95-.25c-.02-.23-.05-.44-.07-.64-.13-1.37-.27-2.75-.39-4.12-.02-.18-.1-.23-.25-.29-.8-.32-1.59-.65-2.38-.99-.07-.03-.13-.05-.19-.05-.08,0-.14,.03-.23,.1-1.13,.95-2.28,1.89-3.42,2.83-.08,.07-.17,.13-.25,.2-1.64-1.16-3.01-2.55-4.17-4.18,.06-.08,.12-.16,.18-.23,.94-1.14,1.88-2.28,2.83-3.42,.12-.15,.14-.25,.05-.43-.34-.78-.67-1.56-.98-2.35-.07-.18-.14-.26-.34-.28-1.5-.13-3-.28-4.5-.41-.17-.02-.22-.09-.25-.25-.29-1.83-.29-3.66,0-5.5,.03-.17,.1-.23,.26-.24,1.5-.14,3-.28,4.5-.41,.19-.02,.26-.09,.33-.26,.31-.8,.64-1.59,.99-2.38,.07-.17,.07-.27-.05-.41-.7-.83-1.39-1.67-2.08-2.51-.32-.38-.63-.77-.95-1.15,1.17-1.65,2.56-3.03,4.2-4.19,.08,.06,.15,.12,.22,.17,1.14,.94,2.28,1.88,3.42,2.83,.09,.08,.17,.11,.25,.11,.06,0,.13-.02,.21-.05,.78-.34,1.56-.66,2.35-.97,.16-.06,.23-.12,.25-.3,.08-.97,.18-1.93,.27-2.89,.06-.62,.12-1.24,.18-1.86,1-.17,1.99-.25,2.98-.25m-.02,24.2h.01c3.67,0,6.65-3.01,6.65-6.69,0-3.68-2.99-6.67-6.66-6.67h0c-3.68,0-6.66,2.99-6.67,6.67,0,3.68,2.99,6.68,6.67,6.68m.02-27.2c-1.14,0-2.31,.1-3.47,.29-1.34,.22-2.36,1.32-2.49,2.67l-.06,.6-.12,1.27-.07,.68v.05c-.35-.29-.71-.58-1.06-.87l-.73-.6c-.07-.06-.14-.12-.22-.18l-.06-.05c-.54-.42-1.19-.63-1.85-.63-.61,0-1.21,.18-1.74,.55-1.9,1.35-3.55,3-4.9,4.9-.79,1.11-.73,2.6,.13,3.65l.29,.35,.66,.8,.48,.58,.22,.27-.57,.05-1.78,.16c-1.53,.14-2.72,1.25-2.95,2.76-.34,2.14-.34,4.31,0,6.43,.24,1.54,1.4,2.63,2.95,2.77,.65,.06,1.31,.12,1.96,.18l.4,.04c-.31,.37-.61,.74-.92,1.11l-.54,.66c-.07,.08-.13,.17-.2,.25l-.04,.06c-.81,1.05-.84,2.49-.07,3.57,1.35,1.9,2.99,3.55,4.88,4.89,.52,.37,1.13,.56,1.74,.56,.65,0,1.3-.21,1.84-.63l.06-.05c.09-.07,.17-.13,.26-.2l.65-.53c.37-.31,.74-.61,1.11-.92,.03,.36,.07,.72,.1,1.08l.08,.87,.05,.45,.02,.22c.14,1.34,1.15,2.43,2.48,2.65,1.14,.19,2.3,.29,3.45,.29s2.3-.1,3.45-.28c1.35-.22,2.37-1.32,2.5-2.68l.07-.77,.17-1.81v-.02c.35,.28,.69,.57,1.03,.85l.73,.61c.06,.05,.13,.1,.21,.17l.1,.08c.55,.44,1.21,.65,1.87,.65s1.36-.23,1.92-.69c.16-.13,.32-.26,.48-.38,.45-.35,.95-.75,1.44-1.25,.58-.59,1.1-1.19,1.61-1.77,.25-.28,.5-.57,.75-.84,1.16-1.28,1.19-3.11,.06-4.44-.49-.58-.97-1.16-1.45-1.74h.14c.74-.08,1.48-.15,2.23-.22,1.36-.12,2.8-1.1,2.97-3.01,.05-.56,.1-1.12,.15-1.68,.1-.3,.15-.62,.15-.95v-.76c0-.32-.05-.65-.16-.95-.05-.53-.1-1.05-.15-1.58-.13-1.67-1.35-2.89-3.04-3.04-.77-.07-1.53-.14-2.3-.21,.41-.49,.81-.98,1.22-1.47l.25-.3c.06-.07,.12-.14,.18-.22l.05-.07c.83-1.04,.86-2.51,.09-3.6-1.33-1.88-2.98-3.53-4.9-4.9-.52-.37-1.13-.56-1.74-.56-.68,0-1.36,.23-1.91,.69l-.61,.5-1.4,1.15c-.03-.33-.06-.66-.09-.98l-.08-.87-.05-.5-.02-.24c-.13-1.34-1.14-2.42-2.46-2.66-1.14-.2-2.3-.3-3.46-.3h0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSoftware);
export default __webpack_public_path__ + "static/media/custom-software.b3cf23e361474d7f4a829b1fedc75d13.svg";
export { ForwardRef as ReactComponent };